module.exports = __webpack_public_path__ + "66d1c58ae2ae7b35e2deaf361d379fa4.pdf";